import type { AppThunk } from '~/@types/app-types';
import { creatorsListActions } from './actions';
import { CreatorApi } from '~/api/creator.api';
import { errorHandler } from '~/store/utils/errorHendler';

export const getCreatorsListThunk: AppThunk = () => async dispatch => {
    dispatch(creatorsListActions.request());
    try {
        const data = await CreatorApi.getListOfCreators();
        dispatch(creatorsListActions.success(data));
    } catch (e) {
        dispatch(creatorsListActions.failure({ error: e }));
        return errorHandler(e, dispatch);
    }
};
